import type { CSSProperties, ReactNode } from 'react';
import { Icon } from './Icon';

export interface ListRowProps {
  title: ReactNode;
  secondary?: ReactNode;
  meta?: ReactNode;
  status?: ReactNode;
  trailing?: ReactNode;
  leading?: ReactNode;
  onClick?: () => void;
  /** Shows the chevron. Only when the row opens another screen. */
  navigates?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

/** A list row, minimum 56 px tall. */
export function ListRow({
  title,
  secondary,
  meta,
  status,
  trailing,
  leading,
  onClick,
  navigates,
  disabled,
  style,
}: ListRowProps) {
  const className = `fw-row${onClick && !disabled ? ' fw-row--tappable' : ''}`;
  const body = (
    <>
      {leading && <span className="fw-row__leading">{leading}</span>}
      <span className="fw-row__main">
        <span className="fw-row__title">{title}</span>
        {secondary && <span className="fw-row__secondary">{secondary}</span>}
        {status}
      </span>
      {meta && <span className="fw-row__meta fw-tnum">{meta}</span>}
      {trailing}
      {navigates && <Icon name="chevron-forward" size={20} className="fw-row__chevron" />}
    </>
  );
  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={className}
        style={style}
      >
        {body}
      </button>
    );
  }
  return (
    <div className={className} style={style}>
      {body}
    </div>
  );
}
